// src/components/tip/WalletDashboard.js

import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../auth/auth-context';
import WalletDashboardInner from './walletDashboardInner';

// Guard wrapper
export default function WalletDashboard() {
  const { businessUrl, staffUrl } = useParams();
  const navigate = useNavigate();
  const { providerUser } = useContext(UserContext);

  useEffect(() => {
    // 1) Not logged in → send to login
    if (!providerUser?.userId) {
      navigate('/login');
    }
    // 2) URL mismatch → send to your own wallet
    else if (providerUser.url !== staffUrl) {
      navigate(`/${businessUrl}/${providerUser.url}/wallet`);
    }
  }, [providerUser, staffUrl, businessUrl, navigate]);

  // Don’t render the inner component until checks pass
  if (!providerUser || providerUser.url !== staffUrl) {
    return null;
  }

  // All clear → render the real dashboard
  return <WalletDashboardInner />;
}
